import script from "./TermsOfSalePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsOfSalePage.vue?vue&type=script&setup=true&lang=ts"

import "./TermsOfSalePage.vue?vue&type=style&index=0&id=9a91b462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a91b462"]])

export default __exports__